var exports = {
  "Qs": "x28a7bf27--d0c5e1--content",
  "uR": "x28a7bf27--d0c5e1--contact-us-block",
  "Yu": "x28a7bf27--d0c5e1--text-block",
  "Qq": "x28a7bf27--d0c5e1--text",
  "Sl": "x28a7bf27--d0c5e1--image",
  "xX": "x28a7bf27--d0c5e1--contact-links-block",
  "qP": "x28a7bf27--d0c5e1--contact-link",
};

module.exports = exports;
